import { msalInstance, loginRequest } from "../authConfig";
import { APIURL } from "../config";

// Exchange MSAL ID token for local JWT (backend validates the token before issuing)
async function exchangeToken(msalIdToken) {
  try {
    const response = await fetch(APIURL + '/token-exchange', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${msalIdToken}`,
      },
      body: JSON.stringify({}),
    });
    const data = await response.json();
    if (data.token) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('userRole', data.role || 'admin');
    }
  } catch (err) {
    console.error('Token exchange failed:', err);
  }
}

export async function loginUser() {
  const accounts = msalInstance.getAllAccounts();

  if (accounts.length > 0) {
    try {
      const silentResult = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      });
      localStorage.setItem("userInfo", JSON.stringify(silentResult.account));
      localStorage.setItem("loginType", "microsoft");
      await exchangeToken(silentResult.idToken);
      return silentResult.account;
    } catch (error) {
      console.error('Silent token acquisition failed, falling back to popup:', error);
    }
  }

  try {
    const popupResult = await msalInstance.loginPopup(loginRequest);
    localStorage.setItem("userInfo", JSON.stringify(popupResult.account));
    localStorage.setItem("loginType", "microsoft");
    await exchangeToken(popupResult.idToken);
    return popupResult.account;
  } catch (popupError) {
    throw popupError;
  }
}


// Check if user is logged in
export async function isLoggedIn() {
  const userInfo = localStorage.getItem("userInfo");
  return !!userInfo;
}

// Logout function
export async function logout() {
  const loginType = localStorage.getItem("loginType");
  try {
    if (loginType === "microsoft") {
      await msalInstance.logoutPopup({
        postLogoutRedirectUri: window.location.origin
      });
      localStorage.clear();
      window.location.href = "/admin";

    }
    else {
      localStorage.clear();
      window.location.href = "/login";
    }
  } catch (error) {
    console.error('Logout failed:', error);
  }
}
